export default {
  text: '{{threshold}} monthly sales: {{amount}}',
  label: '{{threshold}} monthly sales:',
  no_discount: 'no discount',
  discount_badge: '-{{percentage}}%',
};
